import { Box, FormControlLabel, Checkbox, Typography, Divider, Paper, Switch } from '@mui/material';
import { Field, useFormikContext } from 'formik';
import React, { useEffect } from 'react';

const categories = ['KRA', 'Goals', 'Skill', 'Will'];

const Step3ManagerReview = () => {
  const { values, setFieldValue } = useFormikContext();

  const handleCheckboxChange = (category, field) => (e) => {
    setFieldValue(`managerReview.parameters.${category}.${field}`, e.target.checked);
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Manager Review
      </Typography>
      <FormControlLabel
        sx={{ mt: 2 }}
        control={
          <Checkbox
            onChange={(e) => {
              const checked = e.target.checked;
              categories.forEach((category) => {
                setFieldValue(`managerReview.parameters.${category}.included`, checked);
                setFieldValue(`managerReview.parameters.${category}.ratings`, checked);
                setFieldValue(`managerReview.parameters.${category}.comments`, checked);
                setFieldValue(`managerReview.parameters.${category}.ratingsMandatory`, checked);
                setFieldValue(`managerReview.parameters.${category}.commentsMandatory`, checked);
              });
            }}
          />
        }
        label="Select All"
      />
      {/* --------------------------------------------------------------- */}
      {categories.map((category) => {
        return (
          <Paper sx={{ backgroundColor: 'grey.200', borderRadius: 2, mt: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Typography variant="h6" gutterBottom>
                {category}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              {/* <FormControlLabel
                control={
                  <Checkbox
                    checked={values.managerReview.parameters[category].included}
                    onChange={handleCheckboxChange(category, "included")}
                  />
                }
                label="Included"
              /> */}
              <FormControlLabel
                control={
                  <Switch
                    checked={values.managerReview.parameters[category].included}
                    onChange={handleCheckboxChange(category, 'included')}
                  />
                }
                label="Included"
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                flexWrap: 'wrap',
                p: 1,
              }}
            >
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={values.managerReview.parameters[category].included ? false : true}
                      checked={values.managerReview.parameters[category].ratings}
                      onChange={handleCheckboxChange(category, 'ratings')}
                    />
                  }
                  label="Ratings"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={values.managerReview.parameters[category].included ? false : true}
                      checked={values.managerReview.parameters[category].comments}
                      onChange={handleCheckboxChange(category, 'comments')}
                    />
                  }
                  label="Comments"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={values.managerReview.parameters[category].included ? false : true}
                      checked={values.managerReview.parameters[category].ratingsMandatory}
                      onChange={handleCheckboxChange(category, 'ratingsMandatory')}
                    />
                  }
                  label="Ratings Mandatory"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={values.managerReview.parameters[category].included ? false : true}
                      checked={values.managerReview.parameters[category].commentsMandatory}
                      onChange={handleCheckboxChange(category, 'commentsMandatory')}
                    />
                  }
                  label="Comments Mandatory"
                />
              </Box>
            </Box>
          </Paper>
        );
      })}

      {/* ------------------------------------------------------------------------ */}
      {/* {categories.map((category) => (
        <Box key={category}>
          <Typography variant="h6" gutterBottom>
            {category}
          </Typography>
          <Divider />
          <FormControlLabel
            control={
              <Checkbox
                checked={values.managerReview.parameters[category].included}
                onChange={handleCheckboxChange(category, "included")}
              />
            }
            label="Included"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={
                  values.managerReview.parameters[category].ratingsMandatory
                }
                onChange={handleCheckboxChange(category, "ratingsMandatory")}
              />
            }
            label="Ratings Mandatory"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={
                  values.managerReview.parameters[category].commentsMandatory
                }
                onChange={handleCheckboxChange(category, "commentsMandatory")}
              />
            }
            label="Comments Mandatory"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={values.managerReview.parameters[category].ratings}
                onChange={handleCheckboxChange(category, "ratings")}
              />
            }
            label="Ratings"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={values.managerReview.parameters[category].comments}
                onChange={handleCheckboxChange(category, "comments")}
              />
            }
            label="Comments"
          />
        </Box>
      ))} */}
    </Box>
  );
};

export default Step3ManagerReview;
